import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { addTag, getTags, deleteTag } from '../../../views/spenza/utils/admin'

const TagsContext = createContext();

export const useTags = () => useContext(TagsContext);

export const TagsProvider = ({ children }) => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTags = async () => {
    setLoading(true);
    const tagsResult = await getTags();
    tagsResult.sort((a, b) => b.dateCreated.seconds - a.dateCreated.seconds);
    setTags(tagsResult);
    setLoading(false);
  }

  const createTags = async (newUnit) => {
    setLoading(true);
    await addTag(newUnit);
    await fetchTags();
    setLoading(false);
  };

  const removeTag = (tag) => {
    deleteTag(tag.id);
    const newTags = tags.filter(u => u.id !== tag.id)
    setTags(newTags);
  };

  useEffect(() => {
    fetchTags();
  }, []);

  return (
    <TagsContext.Provider
      value={{
        tags,
        createTags,
        removeTag,
        fetchTags,
        loading,
      }}
    >
      {children}
    </TagsContext.Provider>
  );
};

TagsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};